import { useQueryClient } from "@tanstack/react-query";
import {
  Button,
  Dialog,
  Form,
  RadioInput,
  useForm,
  useToast,
} from "@validereinc/common-components";
import type { EventType } from "@validereinc/domain";
import { EventAdapter, Resources } from "@validereinc/domain";
import { Events } from "@validereinc/domain-controllers";
import React from "react";

const { EventStatusOptions } = Events.view;

export const ChangeEventStatusDialog = ({
  isOpen,
  onClose,
  event,
}: {
  isOpen: boolean;
  onClose: (shouldRefetch?: boolean) => void;
  event: EventType;
}) => {
  const form = useForm({ defaultValues: { status: event.status } });
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const onClick = form.handleSubmit(async (formValues) => {
    try {
      await EventAdapter.updateOne({
        id: event.id,
        data: formValues,
      });

      toast.push({
        intent: "success",
        description: `Successfully updated status.`,
      });

      onClose(true);
    } catch (caught) {
      console.error("Error updating event status", caught);

      toast.push({
        intent: "error",
        description: `There was an error updating the event status.`,
      });
    } finally {
      queryClient.invalidateQueries({
        queryKey: ["events", event.id],
      });
      queryClient.invalidateQueries({
        queryKey: [Resources.WORKFLOW],
      });
    }
  });

  return (
    <Dialog
      title="Update Event Status"
      isOpen={isOpen}
      onClose={onClose}
      actionRow={[
        <Button
          key="update-status-button"
          onClick={onClick}
          variant="primary"
        >
          Update Status
        </Button>,
      ]}
    >
      <Form {...form}>
        <RadioInput
          name="status"
          isRequired
          options={EventStatusOptions}
          valueKey="value"
          labelKey="label"
        />
      </Form>
    </Dialog>
  );
};
